import { Component } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { TablerIconsModule } from 'angular-tabler-icons';

@Component({
  selector: 'app-main-cer-cards',
  templateUrl: './main-cards.component.html',
  styleUrls: ['./main-cards.component.scss'],
  standalone: true,
  imports: [MatCardModule, TablerIconsModule],
})
export class MainCerCardsComponent {}
